/**
 * A file path as a CSS `view-transition-name`.
 *
 * A transition name is a custom identifier, so it may not contain the two
 * characters every path is made of — `/` and `.` — nor start with a digit. A
 * path handed over raw produces an invalid declaration, which the browser drops
 * silently: no error, no transition, and nothing in the output naming the cause.
 *
 * **Encoded, not replaced.** Substituting every invalid character with the same
 * `-` collapses `a/b` and `a.b` onto one name, and two elements claiming one
 * name is the other way a transition disappears without saying so. Each
 * character becomes `_` followed by its hex code, which is reversible and
 * therefore cannot collide.
 */
export function transitionName(path: string): string {
  const encoded = path.replace(
    /[^a-zA-Z0-9-]/g,
    (char) => `_${char.codePointAt(0)?.toString(16) ?? 'x'}`,
  );
  return `file-${encoded}`;
}
